import { commonConstants } from '@CaseOne/Common/constants/common.constants';

export const COMMON_DEFAULT_NUMBER_CONSTANTS = {
	DECIMAL_SEPARATOR: commonConstants.defaultNumberDecimalSeparator,
	GROUP_SEPARATOR: commonConstants.defaultNumberGroupSeparator,
	DIGITS_AFTER_DECIMAL: commonConstants.defaultNumberDigitsAfterDecimal,
};
